import { createRouter, createWebHistory } from 'vue-router'
import projects from '../views/projects.vue'
import projectsAdmin from '../views/projectsAdmin.vue'
import CreateProject from '../views/CreateProject.vue'
import ApplyingProject from '../views/ApplyingProject.vue'
// import LawyersPage from '../views/LawyersPage.vue'
// import Project from '../views/Project.vue'
import HomePage from '../views/HomePage.vue'
import LoginPage from '../views/loginSignup.vue'
import ProjectView from '../views/ProjectView.vue'
import editProfile from '../views/editProfile.vue'
import friends from '../views/Friends.vue'
import offersDetails from '../views/offersDetails.vue'
import profile from '../views/profile.vue'
import Updates from '../views/Updates.vue'
import applyCheckout from '../views/apply_checkout.vue'


const routes = [
  {
    path: '/',
    name: 'homepage',
    component: HomePage 
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage 
  },
  {
    path: '/list',
    name: 'projects',
    component: projects 
  },
  {
    path: '/friends',
    name: 'friends',
    component: friends 
  },
  {
    path: '/projects_manager',
    name: 'projects_manager',
    component: projectsAdmin 
  },
  {
    path: '/create_project/:step?',
    name: 'create_project',
    component: CreateProject 
  },
  {
    path: '/create_project/:step/:token',
    name: 'edit project',
    component: CreateProject 
  },
  {
    path: '/applying_project/:step/:token',
    name: 'applying_project',
    component: ApplyingProject 
  },
  // {
  //   path: '/lawyers',
  //   name: 'lawyers',
  //   component: LawyersPage 
  // },
  {
    path: '/project/:token',
    name: 'project',
    component: ProjectView 
  },
  {
    path: '/edit_profile',
    name: 'edit_profile',
    component: editProfile 
  },
  {
    path: '/offers_details/:token',
    name: 'offers_details',
    component: offersDetails 
  },
  {
    path: '/profile/:id',
    name: 'profile',
    component: profile 
  },
  {
    path: '/updates',
    name: 'updates',
    component: Updates
  },
  {
    path: '/apply_checkout/:order_token/:apply_token',
    name: 'apply_checkout',
    component: applyCheckout
  }
  // {
  //   path: '/project',
  //   name: 'project',
  //   component: Project 
  // },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
